import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import Icons from '../../Elements/Icons';
import Tooltip from '../Tooltip';
import { InfoTooltipIconType } from './constants';
import { IconWrapper } from './styled';
export const InfoTooltipIcon = ({ tooltip, placement = 'top', size = 16, dataTestId, dataTestIdIcon, type = InfoTooltipIconType.Info, }) => {
    const { colors } = useTheme();
    const [hovered, setHovered] = React.useState(false);
    const handleMouseEnter = useCallbackRef(() => setHovered(true));
    const handleMouseLeave = useCallbackRef(() => setHovered(false));
    return (_jsxs(Tooltip, { placement: placement, tooltip: tooltip, dataTestId: dataTestId, ContainerComponent: IconWrapper, containerComponentProps: {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
        }, children: [type === InfoTooltipIconType.Info && _jsx(Icons.Info, { size: size, color: colors.grey70_1, filled: hovered, dataTestId: dataTestIdIcon }), type === InfoTooltipIconType.Warning && (_jsx(Icons.Warning, { size: size, color: colors.warning100, filled: hovered, dataTestId: dataTestIdIcon })), type === InfoTooltipIconType.Payment && (_jsx(Icons.Dollar, { size: size, color: colors.critical100, filled: hovered, dataTestId: dataTestIdIcon }))] }));
};
